import React, { useState, useEffect, useMemo } from "react";
import { Calendar, dayjsLocalizer } from "react-big-calendar";
import dayjs from "dayjs";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "../../../../network/api";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Snackbar, Alert } from "@mui/material";
import "./dateHoliday.css";

const localizer = dayjsLocalizer(dayjs);

const DateHoliday = (props) => {
  const [holidayList, setHolidayList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [title, setTitle] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const config = useMemo(() => getConfig(), []);
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };


  const handleEventAdd = () => {
    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
  
    const newHoliday = {
      date: formattedStartDate,
      description: title,
    };
  
    setIsModalOpen(false);
  
    if (eventId) {
      axios
        .patch(`${baseUrl}superadmin/holiday-Update/${eventId}/`, newHoliday, config)
        .then((response) => {
          fetchHolidayList();
          showSnackbar(response.data.message, "success");
        })
        .catch((error) => {
          console.error("Error updating holiday:", error);
          showSnackbar(error.response?.data?.message || "Failed to update holiday", "error");
        });
    } else {
      axios
        .post(`${baseUrl}superadmin/holidays-mark/`, { holiday: [newHoliday] }, config)
        .then((response) => {
          fetchHolidayList();
          showSnackbar(response.data.message, "success");
        })
        .catch((error) => {
          console.error("Error adding holiday:", error);
          showSnackbar(error.response?.data?.message || "Failed to add holiday", "error");
        });
    }
  };
  const handleCancel = () => {
    setStartDate("");
    setTitle(null);
    setIsModalOpen(false);
    setEventId(null);
  };

  const handleSelectSlot = ({ start }) => {
    const selectedEvent = holidayList.find((event) => dayjs(event.date).isSame(dayjs(start).startOf("day"), "day"));

    if (selectedEvent) {
      setEventId(selectedEvent.id);
      setStartDate(dayjs(selectedEvent.date).format("YYYY-MM-DD"));
      setTitle(selectedEvent.description);
    } else {
      setStartDate(dayjs(start).startOf("day").format("YYYY-MM-DD"));
      setTitle(null);
      setEventId(null);
    }

    setIsModalOpen(true);
  };

  const handleDelete = () => {
  if (eventId) {
    axios
      .delete(`${baseUrl}superadmin/holiday-delete/${eventId}/`, config)
      .then((response) => {
        fetchHolidayList();
        handleCancel();
        showSnackbar(response.data.message, "success");
      })
      .catch((error) => {
        console.error("Error deleting holiday:", error);
        showSnackbar(error.response?.data?.message || "Failed to delete holiday", "error");
      });
  }
};
  const fetchHolidayList = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}superadmin/holiday-list/`, config)
      .then((response) => {
        setHolidayList(response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Holiday Error:", error);
        setLoading(false);
      });
  };

  useEffect(fetchHolidayList, []);

  const events = holidayList.map((event) => ({
    id: event.id,
    title: event.description,
    start: dayjs(event.date).startOf("day").toDate(),
    end: dayjs(event.date).endOf("day").toDate(),
  }));

  return (
    <div className="calender-container">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        selectable
        onSelectSlot={handleSelectSlot}
        views={["month"]}
      />
      <Dialog open={isModalOpen} onClose={handleCancel} maxWidth="sm">
        <DialogTitle>{eventId ? "Update Holiday" : "Add Holiday"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="startDate"
            label="Start Date"
            type="date"
            fullWidth
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            margin="dense"
            id="title"
            label="Description"
            type="text"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEventAdd} variant="contained" color="primary" style={{ textTransform: "none" }}>
            {eventId ? "Update" : "Submit"}
          </Button>
          <Button onClick={handleCancel} variant="outlined" color="secondary" style={{ textTransform: "none" }}>
            Cancel
          </Button>
          {eventId && (
            <Button onClick={handleDelete} variant="contained" color="error" style={{ textTransform: "none" }}>
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>

         <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={snackbar.open}
              autoHideDuration={4000}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
              <Alert
                severity={snackbar.severity}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
    </div>
  );
};

export default DateHoliday;
